import React from 'react';
import PropTypes from 'prop-types';

const SearchBox = ({
  styleName, placeholder, onChange, value
}) => (
  <div className={`gx-search-bar ${styleName}`}>
    <div className="gx-form-group">
      <input
        className="ant-input"
        onChange={onChange}
        placeholder={placeholder}
        type="search"
        value={value}
      />
      <span className="gx-search-icon gx-pointer"><i className="icon icon-search" /></span>
    </div>
  </div>
);

SearchBox.propTypes = {
  styleName: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export default SearchBox;
